<h3>{{ "My Payments" | translate }}</h3>
<div class="row mt-4">
  <div class="col-12 col-sm-4">
    <div class="card m-2">
      <div class="card-body d-flex justify-content-between">
        <h5 class="card-title">كورس لاملاء</h5>
        <h6 class="price">200 جنيه</h6>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-4">
    <div class="card my-2">
      <div class="card-body d-flex justify-content-between">
        <h5 class="card-title">كورس النحو</h5>
        <h6 class="price">500 جنيه</h6>
      </div>
    </div>
  </div>
</div>
